import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import About from "../../components/about/about";
import ContactArea from "../../components/ContactArea";
import Footer from "../../components/footer/Footer";
import Hero from "../../components/hero/hero";
import Navbar from "../../components/Navbar/Navbar";
import Pricing from "../../components/Pricing/Pricing";
import ProjectSection from "../../components/ProjectSection/ProjectSection";
import Scrollbar from "../../components/scrollbar/scrollbar";
import ServiceSection from "../../components/ServiceSection/ServiceSection";

const HomePage = () => {
  return (
    <Fragment>
      {/* 🔹 SEO, Open Graph & Twitter Meta Tags */}
      <Helmet>
        <title>Designexs | Creative Graphic Design & Animation Services</title>
        <meta
          name="description"
          content="Designexs offers creative graphic design, 3D product animation, and branding services to help businesses stand out with modern visuals and marketing content."
        />
        <meta
          name="keywords"
          content="Designexs, graphic design, logo design, 3D animation, branding, motion graphics, web design, creative studio, design agency"
        />

        {/* Open Graph Meta */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://designexs.com/" />
        <meta
          property="og:title"
          content="Designexs | Graphic Design & Animation Studio"
        />
        <meta
          property="og:description"
          content="Explore creative graphic design, branding, and animation services by Designexs. Transform your ideas into modern, engaging visuals."
        />
        <meta
          property="og:image"
          content="https://designexs.com/preview-image.jpg"
        />

        {/* Twitter Card Meta */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://designexs.com/" />
        <meta
          name="twitter:title"
          content="Designexs | Graphic Design & Animation Studio"
        />
        <meta
          name="twitter:description"
          content="Creative graphic design and 3D animation services for modern brands."
        />
        <meta
          name="twitter:image"
          content="https://designexs.com/preview-image.jpg"
        />

        {/* Fallback */}
        <link rel="canonical" href="https://designexs.com/" />
      </Helmet>

      <Navbar hclass={"wpo-header-style-1"} topbarNone={"topbar-none"} />
      <Hero />
      <About />
      <ServiceSection />
      <ProjectSection />
      <Pricing />
      <ContactArea />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default HomePage;
